/**
 * @module websocket.event.handlers.flights.flight-deleted
 */
import { store } from '../../../../state/store'
import { setFlightListUpdated } from '../../../../state/websocket.slice'

export default function handleFlightDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleFlightDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setFlightListUpdated(data))
  }
} 